import PropTypes from 'prop-types';
import React from 'react';
import TourHeader from './TourHeader';
import TourNavTabs from './TourNavTabs';
import Loading from '../../../components/Loading';

class TourDetail extends React.Component {
  componentDidMount() {
    if (this.props.needFetch) {
      this.props.requestTour(this.props.id);
    }
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return (<Loading />);
    }
    return (
      <div>
        <TourHeader
          tour={this.props.tour}
          editTour={this.props.editTour}
          addTour={this.props.addTour}
          isTourManager={this.props.isTourManager}
          editTourImage={this.props.editTourImage}
          requestTourManagers={this.props.requestTourManagers}
          tourManagers={this.props.tourManagers}
        />
        <TourNavTabs
          requestBidsets={this.props.requestBidsets}
          requestProposals={this.props.requestProposals}
          tour={this.props.tour}
          active={this.props.active}
          detailTab={this.props.detailTab}
          detailSelect={this.props.detailSelect}
          isTourManager={this.props.isTourManager}
          messages={this.props.messages}
          messageDismiss={this.props.messageDismiss}
          requestBidDetails={this.props.requestBidDetails}
        />
      </div>
    );
  }
}

TourDetail.propTypes = {
  active: PropTypes.string,
  detailTab: PropTypes.string,
  detailSelect: PropTypes.string,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  requestTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  editTourImage: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    state: PropTypes.string.required,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    groups: PropTypes.arrayOf(PropTypes.object).required,
    members: PropTypes.arrayOf(PropTypes.object).required,
    routes: PropTypes.arrayOf(PropTypes.object).required,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

TourDetail.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    // image: 'https://www.whyy.org/img/ontour_logocrop.png',
    groups: [],
    members: [],
    routes: [],
  },
};

export default TourDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/TourDetail.js